import { useState } from "react";

export const useDeleteModal = () => {
  const [open, setOpen] = useState<boolean>(false);

  const closeDeleteModal = () => setOpen(false);

  return {
    open,
    setOpen,
    closeDeleteModal,
  };
};
